<template>
  <div class="switcher-wrapper">
    <div class="switcher-item">
      <input
        id="radio-call-type-0"
        v-model="dataModelChecked"
        :value="null"
        type="radio"
        name="radio-call-type"
        @click="clickAction(null)">
      <label for="radio-call-type-0">All</label>
    </div>

    <div class="switcher-item">
      <input
        id="radio-call-type-2"
        v-model="dataModelChecked"
        value="auto"
        type="radio"
        name="radio-call-type"
        @click="clickAction('auto')">
      <label for="radio-call-type-2">Auto</label>
    </div>
    <div class="switcher-item">
      <input
        id="radio-call-type-3"
        v-model="dataModelChecked"
        value="custom"
        type="radio"
        name="radio-call-type"
        @click="clickAction('custom')">
      <label for="radio-call-type-3">Custom</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallAutoStatus',

  props: {
    value: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      dataModelChecked: this.value
    };
  },

  watch: {
    dataModelChecked (val) {
      this.$emit('input', val);
    },

    value (val) {
      this.dataModelChecked = val;
    }
  },

  methods: {
    clickAction (type) {
      if (this.dataModelChecked === type) {
        this.dataModelChecked = null;
      }
    }
  }
};
</script>
